export const DC_RUNTIME_QUERY_KEY = 'dcRuntime' as const;

export const dcRuntimeKeys = {
  byId: (id: string) => [DC_RUNTIME_QUERY_KEY, 'id', id] as const,
  byWoDetailGlobalId: (woDetailGlobalId: string) =>
    [DC_RUNTIME_QUERY_KEY, 'woDetailGlobalId', woDetailGlobalId] as const
} as const;
